<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            id="back-to-alunos"
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'alunos' })"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Aluno
        </h1>
      </v-col>
    </v-row>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-tabs v-model="tab" background-color="primary" centered dark icons-and-text>
                <v-tabs-slider></v-tabs-slider>

                <v-tab href="#tab-1" :id="'tab-aluno'">
                  Aluno
                  <v-icon>fa-graduation-cap</v-icon>
                </v-tab>

                <v-tab href="#tab-2" :id="'tab-endereco-aluno'">
                  Endereço do Aluno
                  <v-icon>fa-address-card</v-icon>
                </v-tab>

                <v-tab href="#tab-3" :id="'tab-saude'">
                  Saúde
                  <v-icon>mdi-heart-pulse</v-icon>
                </v-tab>

                <v-tab href="#tab-4" :id="'tab-alimentacao'">
                  Alimentação
                  <v-icon>mdi-food-apple</v-icon>
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab">
                <v-tab-item :value="'tab-1'">
                  <v-card flat>
                    <v-card-text>
                      <v-row>
                        <v-col class="pt-5 pb-0" cols="8">
                          <ValidationProvider
                            name="Nome completo"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <e-label>Nome completo</e-label>
                            <v-text-field
                              id="input-nomecompleto"
                              :error-messages="errors"
                              v-model="form.nomecompleto"
                              dense
                              solo
                            />
                          </ValidationProvider>
                        </v-col>

                        <v-col class="pt-5 pb-0" cols="4">
                          <e-label>Número do CPF</e-label>
                          <v-text-field
                            id="input-cpf"
                            v-mask="'###.###.###-##'"
                            v-model="form.cpf"
                            dense
                            solo
                            @blur="verificarCpfExistente"
                            @input="validarCpfAlgoritmo"
                            :error-messages="cpfErroAlgoritmo"
                          />
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="6">
                          <ValidationProvider name="Código do INEP" v-slot="{ errors }">
                            <e-label>Identificação única(INEP)</e-label>
                            <v-text-field
                              id="input-codigo-inep"
                              :error-messages="errors"
                              v-model="form.codigo_inep"
                              :loading="pesquisandoINEP"
                              dense
                              solo
                              v-mask="'############'"
                              :required="!form.inep_status"
                              :rules="[
                                !form.inep_status
                                  ? (v) => !!v || 'Preenchimento obrigatório do INEP'
                                  : '',
                              ]"
                              :disabled="form.inep_status"
                            >
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col>
                          <v-switch
                            id="input-inep-status"
                            cols="6"
                            v-model="form.inep_status"
                            :input-value="form.codigo_inep !== ''"
                          >
                            <template v-slot:label>Aluno sem INEP</template>
                          </v-switch>
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="6">
                          <e-label>Número SUS</e-label>
                          <v-text-field
                            id="input-numero-sus"
                            type="number"
                            v-model="form.numero_sus"
                            dense
                            solo
                          >
                          </v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="6">
                          <e-label>Data de nascimento</e-label>
                          <!-- <v-text-field :error-messages="errors" v-model="form.data_nascimento" dense solo /> -->
                          <ValidationProvider
                            name="Data de nascimento"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <e-date-picker
                              id="input-data-nascimento"
                              :error-messages="errors"
                              v-model="form.data_nascimento"
                              placeholder="dd/mm/yyyy"
                            ></e-date-picker>
                          </ValidationProvider>
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="6">
                          <ValidationProvider
                            name="Filiação 1"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <e-label>Filiação 1</e-label>
                            <v-text-field
                              id="input-filiacao1"
                              :error-messages="errors"
                              v-model="form.filiacao1"
                              dense
                              solo
                            />
                          </ValidationProvider>
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="6">
                          <e-label>Profissão (Filiação 1)</e-label>
                          <v-text-field
                            id="input-profissao-filiacao1"
                            v-model="form.profissao_filiacao1"
                            dense
                            solo
                          />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="6">
                          <e-label>Filiação 2</e-label>
                          <v-text-field id="input-filiacao2" v-model="form.filiacao2" dense solo />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="6">
                          <e-label>Profissão (Filiação 2)</e-label>
                          <v-text-field
                            id="input-profissao-filiacao2"
                            v-model="form.profissao_filiacao2"
                            dense
                            solo
                          />
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="6">
                          <e-label>Gênero </e-label>
                          <e-autocomplete
                            id="select-genero"
                            :items="$constants.sexoList"
                            :return-object="false"
                            :item-value="(value) => value.id"
                            :item-text="(value) => value.descricao"
                            v-model="form.sexo_id"
                            label="Selecione uma opção"
                            dense
                            solo
                          />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="6">
                          <e-label>Cor/Raça</e-label>
                          <e-autocomplete
                            id="select-cor-raca"
                            :items="$constants.corOuRacaList"
                            :return-object="false"
                            v-model="form.cor_ou_raca"
                            label="Selecione uma opção"
                            dense
                            solo
                          />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="6">
                          <e-label>Nacionalidade</e-label>
                          <e-autocomplete
                            id="select-nacionalidade"
                            :items="$constants.nacionalidadeList"
                            :return-object="false"
                            :item-text="(value) => value"
                            :item-value="(value) => value"
                            v-model="form.naturalidade"
                            label="Selecione uma opção"
                            dense
                            solo
                          />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="6">
                          <e-label>País de nacionalidade</e-label>
                          <v-text-field
                            id="input-pais-nacionalidade"
                            v-model="form.nacionalidade"
                            dense
                            solo
                          />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="6">
                          <e-label>UF de nascimento</e-label>
                          <e-autocomplete
                            id="select-uf-nascimento"
                            :items="$constants.estadosList"
                            :return-object="false"
                            :item-text="(item) => item.codigo"
                            :item-value="(item) => item.codigo"
                            v-model="form.estadualidade"
                            @change="(event) => atualizarEstado(event)"
                            label="Selecione uma opção"
                            dense
                            solo
                          />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="6">
                          <e-label>Município de nascimento</e-label>
                          <e-autocomplete
                            id="select-municipio-nascimento"
                            :items="municipiosNasc"
                            :return-object="false"
                            :item-text="(item) => item"
                            :item-value="(item) => item"
                            v-model="form.municipalidade"
                            label="Selecione uma opção"
                            dense
                            solo
                          />
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="12">
                          <e-label
                            >Aluno(a) com deficiência, transtorno do espectro autista ou altas
                            habilidades/superdotação</e-label
                          >
                          <v-switch id="switch-especial" v-model="form.especial"></v-switch>
                        </v-col>
                        <template v-if="form.especial">
                          <v-col cols="12">
                            <h4>
                              Tipo de deficiência, transtorno do espectro autista ou altas
                              habilidades/superdotação
                            </h4>
                          </v-col>
                          <v-col class="pt-0 pb-0" cols="4">
                            <e-label>Deficiência</e-label>

                            <e-autocomplete
                              id="select-deficiencia"
                              clearable
                              :items="$constants.tipoDeDeficienciaList"
                              :return-object="false"
                              v-model="form.tipos_de_deficiencia"
                              label="Selecione uma opção"
                              multiple
                              dense
                              solo
                            />
                          </v-col>
                          <v-col class="pt-0 pb-0" cols="4">
                            <e-label>Transtorno do espectro autista</e-label>

                            <e-autocomplete
                              id="select-transtorno"
                              clearable
                              :items="$constants.tipoDeTranstornoDoEspectroAutistaList"
                              :return-object="false"
                              v-model="form.tipos_de_transtornos"
                              label="Selecione uma opção"
                              multiple
                              dense
                              solo
                            />
                          </v-col>

                          <v-col class="pt-0 pb-0" cols="4">
                            <e-label>Altas habilidades/superdotação</e-label>

                            <e-autocomplete
                              id="select-altas-habilidades"
                              clearable
                              :items="$constants.tipoDeAltasHabilidadesList"
                              :return-object="false"
                              v-model="form.tipos_de_altas_habilidades"
                              label="Selecione uma opção"
                              multiple
                              dense
                              solo
                            />
                          </v-col>
                        </template>

                        <v-col v-if="form.especial" class="mb-6">
                          <e-label>Laudo Infantil</e-label>
                          <div class="dropboxStyles">
                            <input
                              id="fileUpload"
                              class="input-file-upload"
                              type="file"
                              @change="selectFile"
                            />
                            <span v-if="!pdf" style="cursor: pointer">Upload</span>

                            <span v-if="pdf">
                              <v-chip
                                id="chip-file"
                                v-if="pdf"
                                class="ma-2"
                                color="green"
                                label
                                text-color="white"
                              >
                                {{ pdf.target.files[0].name }}
                              </v-chip>
                            </span>

                            <span v-if="form?.laudo && !pdf">
                              <v-chip
                                id="chip-file"
                                v-if="form?.laudo && !pdf"
                                class="ma-2"
                                color="green"
                                label
                                text-color="white"
                              >
                                {{ form?.laudo }}
                              </v-chip>
                            </span>

                            <span v-if="pdf">
                              <v-btn
                                v-if="pdf"
                                id="delete-pdf"
                                class="mx-2"
                                fab
                                dark
                                small
                                color="red"
                                @click="apagarLaudo"
                              >
                                <v-icon dark> mdi-close </v-icon>
                              </v-btn>
                            </span>

                            <span v-if="form.laudo">
                              <v-btn
                                v-if="form.laudo"
                                id="delete-laudo"
                                class="mx-2"
                                fab
                                dark
                                small
                                color="red"
                                @click="apagarLaudoForm"
                              >
                                <v-icon dark> mdi-close </v-icon>
                              </v-btn>
                            </span>

                            <span v-if="form.laudo">
                              <v-btn
                                v-if="form.laudo"
                                id="download-laudo"
                                class="mx-2"
                                fab
                                dark
                                small
                                color="red"
                                @click="downloadLaudo"
                              >
                                <v-icon dark> mdi-download </v-icon>
                              </v-btn>
                            </span>
                          </div>
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="12">
                          <h4>
                            Recursos para uso do(a) aluno(a) em sala de aula e para participação em
                            avaliações do Inep (Saeb)
                          </h4>
                          <v-row class="">
                            <v-col
                              class="pt-0 pb-0"
                              cols="4"
                              v-for="(el, index) of $constants.recursosSaebList"
                              :key="index"
                            >
                              <v-checkbox
                                :id="`checkbox-recursos-saeb-${index}`"
                                v-model="recursos_saeb[index]"
                                :label="el"
                                :value="el"
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <h4>DOCUMENTO</h4>
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="5">
                          <e-label> Número de Identificação Social (NIS) </e-label>
                          <v-text-field id="numero-nis" v-model="form.numero_nis" dense solo />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="7">
                          <e-label>
                            Número da matrícula da certidão de nascimento (certidão nova)
                          </e-label>
                          <v-text-field
                            id="input-matricula-certidao"
                            @keyup="preencherCamposCertidao"
                            v-model="form.matricula_certidao_de_nascimento"
                            dense
                            solo
                            type="number"
                            hide-spin-buttons
                            maxlength="32"
                          />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="4">
                          <e-label> N° Do Livro (certidão)</e-label>
                          <v-text-field
                            id="input-livro-certidao"
                            v-model="form.livro"
                            dense
                            solo
                            disabled
                          />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="4">
                          <e-label> Folha (certidão)</e-label>
                          <v-text-field
                            id="input-folha-certidao"
                            v-model="form.folha"
                            dense
                            solo
                            disabled
                          />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="4">
                          <e-label> Termo (certidão)</e-label>
                          <v-text-field
                            id="input-termo-certidao"
                            v-model="form.termo"
                            dense
                            solo
                            disabled
                          />
                        </v-col>

                        <e-uploads-images
                          :dadosImgCarteira="imgCarteiraUrl"
                          :dadosImgAluno="imgAlunoUrl"
                          @imagem-aluno-form="atualizarImagemAluno($event)"
                          @imagem-carteira-form="atualizarImagemCarteira($event)"
                        />

                        <v-col class="pt-5 pb-5" cols="12">
                          <v-btn
                            id="btn-proximo-tab-1-para-2"
                            color="primary"
                            @click="changeTab(2)"
                            block
                            >Proximo</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item :value="'tab-2'">
                  <v-card flat>
                    <v-card-text>
                      <v-row>
                        <v-col class="pt-5 pb-0" cols="12">
                          <h4>DADOS SOBRE A ÁREA RESIDENCIAL DO(A) ALUNO(A)</h4>
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="6">
                          <e-label> País de residência </e-label>
                          <v-text-field
                            id="input-pais-residencia"
                            v-model="form.pais_residencia"
                            dense
                            solo
                          />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="4">
                          <e-label> CEP </e-label>
                          <v-text-field
                            id="input-cep"
                            v-mask="`#####-###`"
                            v-model="form.cep"
                            dense
                            solo
                          />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="2">
                          <e-label> UF </e-label>
                          <e-autocomplete
                            id="select-uf-residencia"
                            :items="$constants.estadosList"
                            :return-object="false"
                            :item-text="(item) => item.codigo"
                            :item-value="(item) => item.codigo"
                            v-model="form.uf_residencia"
                            @change="(event) => atualizarEstadoRes(event)"
                            label="Selecione uma opção"
                            dense
                            solo
                          />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label> Endereço </e-label>
                          <v-text-field id="input-endereco" v-model="form.endereco" dense solo />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label> Número </e-label>
                          <v-text-field id="input-numero" v-model="form.numero" dense solo />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label> Bairro </e-label>
                          <v-text-field id="input-bairro" v-model="form.bairro" dense solo />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label> Complemento </e-label>
                          <v-text-field
                            id="input-complemento"
                            v-model="form.complemento"
                            dense
                            solo
                          />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="6">
                          <e-label> Município de residência </e-label>
                          <e-autocomplete
                            id="select-municipio-residencia"
                            :items="municipiosRes"
                            :return-object="false"
                            :item-text="(item) => item"
                            :item-value="(item) => item"
                            v-model="form.municipio_residencia"
                            label="Selecione uma opção"
                            dense
                            solo
                          />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="6">
                          <e-label> Zona de Residência </e-label>
                          <e-autocomplete
                            id="select-zona-residencia"
                            :items="$constants.zonaResidenciaList"
                            :return-object="false"
                            v-model="form.zona_residencia"
                            label="Selecione uma opção"
                            dense
                            solo
                          />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="6">
                          <e-label>Localização diferenciada de residência</e-label>
                          <e-autocomplete
                            id="select-localizacao-diferenciada-residencia"
                            :items="$constants.localizacaoDiferenciadaDeResidenciaList"
                            :return-object="false"
                            v-model="form.zona_diferenciada_residencia"
                            label="Selecione uma opção"
                            dense
                            solo
                          />
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="2">
                          <e-label>Transporte escolar público</e-label>
                          <v-switch
                            id="input-transporte-escolar-publico"
                            v-model="form.utiliza_transporte_publico"
                            color="primary"
                            :label="form.utiliza_transporte_publico ? 'Utiliza' : 'Não utiliza'"
                            hide-details
                          ></v-switch>
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="4" v-if="form.utiliza_transporte_publico">
                          <e-label> Número de rota </e-label>
                          <v-text-field
                            id="input-numero-rota"
                            v-model="form.numero_de_rota"
                            dense
                            solo
                          />
                        </v-col>
                        <v-col cols="6">
                          <v-btn
                            id="btn-anterior-tab-3-para-2"
                            color="primary"
                            @click="changeTab(1)"
                            block
                          >
                            Anterior
                          </v-btn>
                        </v-col>
                        <v-col cols="6">
                          <v-btn
                            id="btn-proximo-tab-3-para-4"
                            color="primary"
                            @click="changeTab(3)"
                            block
                          >
                            Próximo
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item :value="'tab-3'">
                  <v-card flat>
                    <v-card-text>
                      <!-- DADOS SOBRE A SAÚDE -->
                      <v-row>
                        <v-col class="pt-5 pb-0" cols="12">
                          <h4>INFORMAÇÕES SOBRE A SAÚDE</h4>
                        </v-col>

                        <!-- Alergia a medicamentos -->
                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>Tem alergia a algum medicamento?</e-label>
                          <v-combobox
                            id="input-alergia-medicamento"
                            v-model="selectedItemSaude"
                            :items="itemsEscolhas"
                            label="Selecione uma opção"
                            dense
                            solo
                            @change="openTextFieldSaude"
                          ></v-combobox>
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="9">
                          <v-row v-show="true" style="min-height: 56px">
                            <v-col cols="12" v-show="selectedItemSaude === 'Sim'">
                              <e-label>Qual(is) medicamento(s):</e-label>
                              <v-text-field
                                id="input-alergia-medicamento-descricao"
                                label="Descrição"
                                v-model="textFieldValueDetalhe"
                                dense
                                solo
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>

                        <!-- Acompanhamento médico ou psicológico -->
                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>Tem acompanhamento médico ou psicólogo?</e-label>
                          <v-combobox
                            id="input-acompanhamento-medico"
                            v-model="selectedItemAcompanhamento"
                            :items="itemsEscolhas"
                            label="Selecione uma opção"
                            dense
                            solo
                            @change="openTextFieldSaude"
                          ></v-combobox>
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="9">
                          <v-row v-show="true" style="min-height: 56px">
                            <v-col cols="12" v-show="selectedItemAcompanhamento === 'Sim'">
                              <e-label>Motivo(s):</e-label>
                              <v-text-field
                                id="input-acompanhamento-medico-descricao"
                                label="Descrição"
                                v-model="textFieldValueAcompanhamento"
                                dense
                                solo
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>

                        <!-- Restrição a atividades físicas -->
                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>Tem restrição a alguma atividade física?</e-label>
                          <v-combobox
                            id="input-restricao-atividade-fisica"
                            v-model="selectedItemRestricao"
                            :items="itemsEscolhas"
                            label="Selecione uma opção"
                            dense
                            solo
                            @change="openTextFieldSaude"
                          ></v-combobox>
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="9">
                          <v-row v-show="true" style="min-height: 56px">
                            <v-col cols="12" v-show="selectedItemRestricao === 'Sim'">
                              <e-label>Qual(is) restrição(ões):</e-label>
                              <v-text-field
                                id="input-restricao-atividade-fisica-descricao"
                                label="Descrição"
                                v-model="textFieldValueRestricao"
                                dense
                                solo
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>

                        <!-- Distúrbios -->
                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>Apresenta algum distúrbio?</e-label>
                          <v-combobox
                            id="input-disturbio"
                            v-model="selectedItemDisturbio"
                            :items="itemsEscolhas"
                            label="Selecione uma opção"
                            dense
                            solo
                            @change="openTextFieldSaude"
                          ></v-combobox>
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="9">
                          <v-row v-show="true" style="min-height: 112px">
                            <v-col cols="6" v-show="selectedItemDisturbio === 'Sim'">
                              <e-label>Qual(is) distúrbio(s):</e-label>
                              <v-text-field
                                id="input-disturbio-descricao"
                                label="Descrição"
                                v-model="textFieldValueDisturbio"
                                dense
                                solo
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6" v-show="selectedItemDisturbio === 'Sim'">
                              <e-label>Instruções sobre o procedimento:</e-label>
                              <v-text-field
                                id="input-disturbio-procedimento-descricao"
                                label="Descrição"
                                v-model="textFieldValueDisturbioProcedimento"
                                dense
                                solo
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>

                        <!-- Vacinas -->
                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>Tem todas as vacinas em dias?</e-label>
                          <v-combobox
                            id="input-vacinas"
                            v-model="selectedItemVacinas"
                            :items="itemsEscolhas"
                            label="Selecione uma opção"
                            dense
                            solo
                            @change="openTextFieldSaude"
                          ></v-combobox>
                        </v-col>
                        <v-col class="pt-9 pb-0" cols="9">
                          <v-row v-show="true" style="min-height: 56px">
                            <v-col cols="6" v-show="selectedItemVacinas === 'Não'">
                              <e-label id="obs-vacinas-nao"
                                >OBS.: Se a resposta for "Não", providenciar.</e-label
                              >
                            </v-col>
                          </v-row>
                        </v-col>

                        <v-col class="pt-0 pb-0" cols="3" v-if="form.sexo_id === 2">
                          <e-label>Gravidez na Adolescência?</e-label>
                          <v-combobox
                            id="input-gravidez-adolescencia"
                            v-model="selectedItemGravidezAdolescencia"
                            :items="itemsEscolhas"
                            label="Selecione uma opção"
                            dense
                            solo
                            @change="openTextFieldSaude"
                          ></v-combobox>
                        </v-col>

                        <v-col class="pt-9 pb-0" cols="9">
                          <v-row v-show="true" style="min-height: 56px">
                            <v-col cols="6" v-show="selectedItemGravidezAdolescencia === 'Sim'">
                              <e-label id="obs-gravidez-adolescencia"></e-label>
                            </v-col>
                          </v-row>
                        </v-col>

                        <v-col cols="6">
                          <v-btn
                            id="btn-anterior-tab-4-para-3"
                            color="primary"
                            @click="changeTab(2)"
                            block
                            >Anterior</v-btn
                          >
                        </v-col>
                        <v-col cols="6">
                          <v-btn
                            id="btn-proximo-tab-4-para-5"
                            color="primary"
                            @click="changeTab(4)"
                            block
                            >Próximo</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item :value="'tab-4'">
                  <v-card flat>
                    <v-card-text>
                      <v-row>
                        <v-col class="pt-5 pb-0" cols="12">
                          <h4>INFORMAÇÕES SOBRE ALIMENTAÇÃO</h4>
                        </v-col>

                        <!-- Restrição alimentar -->
                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>Apresenta alguma restrição alimentar?</e-label>
                          <v-combobox
                            id="input-restricao-alimentar"
                            v-model="selectedItemRestricaoAlimentar"
                            :items="itemsEscolhas"
                            label="Selecione uma opção"
                            dense
                            solo
                            @change="openTextFieldSaude"
                          ></v-combobox>
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="9">
                          <v-row v-show="true" style="min-height: 56px">
                            <v-col cols="12" v-show="selectedItemRestricaoAlimentar === 'Sim'">
                              <e-label>Qual(is) restrição(ões):</e-label>
                              <v-text-field
                                id="input-restricao-alimentar-descricao"
                                label="Descrição"
                                v-model="textFieldValueRestricaoAlimentar"
                                dense
                                solo
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>

                        <!-- Medicação de uso contínuo -->
                        <v-col class="pt-0 pb-0" cols="3">
                          <e-label>Toma medicação de uso contínuo?</e-label>
                          <v-combobox
                            id="input-medicacao"
                            v-model="selectedItemMedicacao"
                            :items="itemsEscolhas"
                            label="Selecione uma opção"
                            dense
                            solo
                            @change="openTextFieldSaude"
                          ></v-combobox>
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="9">
                          <v-row v-show="true" style="min-height: 56px">
                            <v-col cols="12" v-show="selectedItemMedicacao === 'Sim'">
                              <e-label>Qual(is) medicação(ões):</e-label>
                              <v-text-field
                                id="input-medicacao-descricao"
                                label="Descrição"
                                v-model="textFieldValueMedicacao"
                                dense
                                solo
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>

                        <!-- Observações -->
                        <v-col class="pt-0 pb-0" cols="12">
                          <v-row v-show="true" style="min-height: 56px">
                            <v-col cols="12">
                              <e-label>Observações:</e-label>
                              <v-text-field
                                id="input-observacoes"
                                label="Descrição"
                                v-model="textFieldValueObservacoes"
                                dense
                                solo
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>

                        <!-- Botões de navegação -->
                        <v-col cols="6">
                          <v-btn
                            id="btn-anterior-tab-5-para-4"
                            color="primary"
                            @click="changeTab(3)"
                            block
                            >Anterior</v-btn
                          >
                        </v-col>
                        <v-col cols="6">
                          <v-btn
                            id="btn-enviar-dados"
                            color="primary"
                            :disabled="submittingForm"
                            :loading="submittingForm"
                            type="submit"
                            block
                          >
                            Enviar Dados
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-dialog v-model="mostrarModalRecuperacao" max-width="500">
              <v-card>
                <v-card-title class="text-h6 grey--text text--darken-3">
                  Aluno já cadastrado
                </v-card-title>

                <v-card-text>
                  Existe um aluno com este CPF que foi deletado.<br />
                  Deseja recuperá-lo?
                </v-card-text>

                <v-card-actions class="justify-end">
                  <v-btn text color="grey darken-1" @click="cancelarRecuperacao"> Cancelar </v-btn>
                  <v-btn color="primary" @click="restaurarAluno"> Recuperar </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <CpfDuplicadoModal
            :visible="mostrarModalCpfDuplicado"
            :tipo="cpfTipoEncontrado"
            :nome="cpfDadosEncontrados?.nome"
            contexto="aluno"
            @close="fecharModalCpf"
          />
        </v-row>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import ELabel from "../../components/ELabel.vue";
import EUploadsImages from "../../components/Alunos/EUploadsImages.vue";
import CpfDuplicadoModal from "../../components/CpfDuplicadoModal.vue";
import useCpfValidation from "../../composables/useCpfValidation";

const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const STATUS_SUCCESS = 2;
const STATUS_FAILED = 3;

export default {
  components: { ELabel, EUploadsImages, CpfDuplicadoModal },
  setup() {
    const { validateCpfAlgorithm, getCpfErrorMessage } = useCpfValidation();
    return { validateCpfAlgorithm, getCpfErrorMessage };
  },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    "form.codigo_inep": function (newVal) {
      if (newVal) {
        this.form.inep_status = false;
      } else {
        this.form.inep_status = true;
      }
    },
    "form.inep_status": function (newVal) {
      if (newVal) {
        this.form.codigo_inep = null;
      }
    },
    form: {
      deep: true,
      handler() {
        if (this.nextInepTimeoutCall) {
          clearTimeout(this.nextInepTimeoutCall);
        }

        this.nextInepTimeoutCall = setTimeout(() => {
          this.verificarCodigoINEP();
        }, 500);
      },
    },
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    selected() {
      return this.form.selected;
    },
    ...mapGetters("Auth", ["user"]),
  },

  mounted() {
    this.reset();
    this.loadFormData();
  },

  data() {
    return {
      pdf: null,
      submittingForm: false,
      recursos_saeb: [],
      form: {
        naturalidade: "Brasileira",
      },
      nextInepTimeoutCall: null,
      pesquisandoINEP: false,
      municipiosNasc: [],
      municipiosRes: [],
      edit: true,
      imgAlunoUrl: null,
      imgAlunoName: null,
      imgCarteiraUrl: null,
      imgCarteiraName: null,
      file_upload: null,
      currentStatus: null,
      tab: "",
      itemsEscolhas: ["Sim", "Não"],
      selectedItemSaude: null,
      selectedItemAcompanhamento: null,
      selectedItemVacinas: null,
      selectedItemGravidezAdolescencia: null,
      selectedItemRestricao: null,
      selectedItemDisturbio: null,
      selectedItemRestricaoAlimentar: null,
      selectedItemMedicacao: null,
      textFieldOpen: false,
      textFieldValueDetalhe: "",
      textFieldValueAcompanhamento: "",
      textFieldValueRestricao: "",
      textFieldValueDisturbio: "",
      textFieldValueDisturbioProcedimento: "",
      textFieldValueRestricaoAlimentar: "",
      textFieldValueMedicacao: "",
      textFieldValueObservacoes: "",
      cpfJaExiste: false,
      cpfErroAlgoritmo: null,
      alunoFoiDeletado: false,
      cpfEncontrado: null,
      mostrarModalRecuperacao: false,
      recuperacaoRecusada: false,
      cpfTipoEncontrado: null,
      cpfDadosEncontrados: null,
      mostrarModalCpfDuplicado: false,
    };
  },

  methods: {
    validarCpfAlgoritmo() {
      this.cpfErroAlgoritmo = this.getCpfErrorMessage(this.form.cpf);
    },

    async verificarCpfExistente() {
      const cpfLimpo = this.form.cpf.replace(/\D/g, "");

      if (!cpfLimpo || cpfLimpo.length !== 11) {
        this.cpfJaExiste = false;
        return;
      }

      if (!this.validateCpfAlgorithm(this.form.cpf)) {
        this.cpfJaExiste = false;
        return;
      }

      try {
        const result = await this.$services.alunosService.verificarCpfGlobal(cpfLimpo);

        if (!result.existe) {
          this.cpfJaExiste = false;
          this.cpfTipoEncontrado = null;
          this.cpfDadosEncontrados = null;
          return;
        }

        if (this.editing && result.tipo === "aluno" && result.dados.id === this.form.id) {
          this.cpfJaExiste = false;
          this.cpfTipoEncontrado = null;
          this.cpfDadosEncontrados = null;
          return;
        }

        this.cpfJaExiste = true;
        this.cpfTipoEncontrado = result.tipo;
        this.cpfDadosEncontrados = result.dados;

        if (result.tipo === "aluno") {
          this.alunoFoiDeletado = result.dados.foi_deletado;

          if (result.dados.foi_deletado && !this.recuperacaoRecusada) {
            this.cpfEncontrado = cpfLimpo;
            this.mostrarModalRecuperacao = true;
          } else if (!result.dados.foi_deletado) {
            this.mostrarModalCpfDuplicado = true;
          }
        } else {
          this.mostrarModalCpfDuplicado = true;
        }
      } catch (error) {
        this.$toast.danger("Erro ao verificar CPF.");
        this.cpfJaExiste = false;
      }
    },

    fecharModalCpf() {
      this.mostrarModalCpfDuplicado = false;
      this.form.cpf = "";
    },

    async restaurarAluno() {
      try {
        const data = await this.$services.alunosService.restaurarPorCpf(this.cpfEncontrado);
        this.$router.push({ name: "alunos.edit", params: { aluno_id: data.aluno_id } }).then(() => {
          window.location.reload();
        });
        this.$toast.success(data.message);
      } catch (error) {
        this.$toast.danger("Erro ao restaurar o aluno.");
      }
    },
    cancelarRecuperacao() {
      this.mostrarModalRecuperacao = false;
      this.recuperacaoRecusada = true;
    },
    atualizarEstado(value) {
      if (value) {
        this.municipiosNasc = this.$constants.municipios[value].cidades;
      }
    },

    atualizarEstadoRes(value) {
      if (value) {
        this.municipiosRes = this.$constants.municipios[value].cidades;
      }
    },

    apagarLaudo() {
      document.querySelector("#fileUpload").value = "";
      this.pdf = null;
    },

    apagarLaudoForm() {
      document.querySelector("#fileUpload").value = "";
      this.pdf = null;
      this.form.laudo = null;
    },

    selectFile(event) {
      if (this.pdf && event.target.files[0].type === "application/pdf") {
        this.pdf = null;
      }

      if (event.target.files[0].type === "application/pdf") {
        this.pdf = event;
        return;
      }

      this.$toast.danger("Formato de arquivo Inválido");
    },

    changeTab(tabindex) {
      this.tab = `tab-${tabindex}`;
    },

    myFunctionToValidateFields() {
      this.podeEnviarFormulario = [];
      this.validateField("cepResponsavel", 5);
      this.validateField("emailResponsavel", 3);
      this.validateField("cpfResponsavel", 4);
      this.validateField("nomeResponsavel", 4);
      this.validateField("cepAluno", 3);
      this.validateField("emailAluno", 1);
      this.validateField("dataNascimento", 1);
      this.validateField("filiacao2", 1);
      this.validateField("genero", 1);
      this.validateField("nomecompleto", 1);
      // this.validateField('nomeirmao', 4);

      if (!this.podeEnviarFormulario.includes(false)) {
        this.submitForm();
      }
    },

    async validateField(field, tabindex) {
      const provider = this.$refs[field];
      if (provider) {
        provider.validate().then((response) => {
          if (!response.valid) {
            this.$toast.danger(response.errors[0]);
            this.changeTab(tabindex);
          }
          this.podeEnviarFormulario.push(response.valid);
        });
      }
    },

    async pegarAluno() {
      try {
        const { aluno_id } = this.$route.params;
        const aluno = await this.$services.alunosService.pegarAluno(aluno_id);
        return aluno;
      } catch (error) {
        return this.$handleError(error);
      }
    },

    async downloadLaudo() {
      try {
        const { aluno_id } = this.$route.params;
        const data = await this.$services.alunosService.downloadLaudo(aluno_id);
        return data;
      } catch (error) {
        return this.$handleError(error);
      }
    },

    async submitForm() {
      this.form.especial = Boolean(this.form.especial);
      this.form.recursos_saeb = this.recursos_saeb;
      this.submittingForm = true;
      this.form.image_carteira = this.imgCarteiraName;
      this.form.imagem = this.imgAlunoName;

      this.handleHealthlyFields();

      try {
        if (this.editing) {
          const response = await this.$services.alunosService.atualizarAluno(this.form);
          if (this.pdf) {
            const formData = new FormData();
            formData.append("file", this.pdf.target.files[0]);
            await this.$services.alunosService.uploadLaudo(formData, this.form.id);
          }

          this.$toast.success("Aluno atualizado com sucesso");
        } else {
          const alunoResponse = await this.$services.alunosService.criarAluno(this.form);

          if (this.pdf) {
            if (alunoResponse) {
              const formData = new FormData();
              formData.append("file", this.pdf.target.files[0]);
              await this.$services.alunosService.uploadLaudo(formData, alunoResponse.id);
            }
          }

          this.$toast.success("Aluno criado com sucesso");
        }
        this.$router.push({ name: "alunos" });
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
    },

    handleHealthlyFields() {
      this.form.selectedItemSaude = this.selectedItemSaude;
      this.form.saude_detalhe = this.selectedItemSaude === "Sim" ? this.textFieldValueDetalhe : " ";

      this.form.selectedItemAcompanhamento = this.selectedItemAcompanhamento;
      this.form.acompanhamento_detalhe =
        this.selectedItemAcompanhamento === "Sim" ? this.textFieldValueAcompanhamento : " ";

      this.form.selectedItemRestricao = this.selectedItemRestricao;
      this.form.restricao_detalhe =
        this.selectedItemRestricao === "Sim" ? this.textFieldValueRestricao : " ";

      this.form.selectedItemDisturbio = this.selectedItemDisturbio;
      this.form.disturbio_detalhe =
        this.selectedItemDisturbio === "Sim" ? this.textFieldValueDisturbio : " ";
      this.form.disturbio_procedimento =
        this.selectedItemDisturbio === "Sim" ? this.textFieldValueDisturbioProcedimento : " ";

      this.form.selectedItemVacinas = this.selectedItemVacinas;
      this.form.vacinas_detalhe =
        this.selectedItemVacinas === "Sim" ? this.textFieldValueVacinas : " ";

      this.form.selectedItemGravidezAdolescencia = this.selectedItemGravidezAdolescencia;

      this.form.selectedItemRestricaoAlimentar = this.selectedItemRestricaoAlimentar;
      this.form.restricao_alimentar_detalhe =
        this.selectedItemRestricaoAlimentar === "Sim" ? this.textFieldValueRestricaoAlimentar : " ";

      this.form.selectedItemMedicacao = this.selectedItemMedicacao;
      this.form.medicacao_detalhe =
        this.selectedItemMedicacao === "Sim" ? this.textFieldValueMedicacao : " ";

      this.form.observacoes = this.textFieldValueObservacoes;
    },

    async loadFormData() {
      const aluno = await this.pegarAluno();
      if (aluno) {
        this.edit = false;
        if (aluno.codigo_inep) {
          this.form.inep_status = false;
        }
      }
      this.atualizarEstadoRes(aluno.uf_residencia);
      this.atualizarEstado(aluno.estadualidade);
      if (aluno.imagem) {
        this.currentStatus = STATUS_SAVING;
      }
      this.recursos_saeb = aluno.recursos_saeb ?? [];

      this.form = {
        ...aluno,
      };

      if (this.form.image_carteira) {
        this.imgCarteiraUrl = `${process.env.VUE_APP_API_HOST}carteira-vacina/uploads/${this.form.image_carteira}`;
        this.imgCarteiraName = this.form.image_carteira;
      }

      if (this.form.imagem) {
        this.imgAlunoUrl = `${process.env.VUE_APP_API_HOST}imagem-do-aluno/uploads/${this.form.imagem}`;
        this.imgAlunoName = this.form.imagem;
      }

      this.textFieldValueDetalhe = aluno.saude_detalhe;
      this.textFieldValueAcompanhamento = aluno.acompanhamento_detalhe;
      this.textFieldValueRestricao = aluno.restricao_detalhe;
      this.textFieldValueDisturbio = aluno.disturbio_detalhe;
      this.textFieldValueDisturbioProcedimento = aluno.disturbio_procedimento;
      this.textFieldValueVacinas = aluno.vacinas_detalhe;
      this.textFieldValueRestricaoAlimentar = aluno.restricao_alimentar_detalhe;
      this.textFieldValueMedicacao = aluno.medicacao_detalhe;
      this.textFieldValueObservacoes = aluno.observacoes;

      this.selectedItemSaude = aluno.selectedItemSaude;
      this.selectedItemAcompanhamento = aluno.selectedItemAcompanhamento;
      this.selectedItemRestricao = aluno.selectedItemRestricao;
      this.selectedItemDisturbio = aluno.selectedItemDisturbio;
      this.selectedItemVacinas = aluno.selectedItemVacinas;
      this.selectedItemGravidezAdolescencia = aluno.selectedItemGravidezAdolescencia;
      this.selectedItemRestricaoAlimentar = aluno.selectedItemRestricaoAlimentar;
      this.selectedItemMedicacao = aluno.selectedItemMedicacao;
    },

    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },

    filesChange(fileList) {
      if (!fileList.length) return;

      this.base64Img = "";

      const reader = new FileReader();

      reader.onload = (event) => {
        this.base64Img = event.target.result;
      };

      reader.readAsDataURL(fileList[0]);

      if (fileList.length > 1) {
        this.countImagem = true;
        setTimeout(() => {
          this.countImagem = false;
        }, 4000);
      }
      Array.from(Array(fileList.length).keys()).map((x) => {
        this.imageAluno = fileList[x];
        return fileList[x];
      });

      this.currentStatus = STATUS_SAVING;
    },

    async verificarCodigoINEP() {
      if (this.editing || !this.form.codigo_inep) return;
      this.pesquisandoINEP = true;
      try {
        const aluno = await this.$services.alunosService.getAlunoComINEP(this.form.codigo_inep);
        if (aluno) {
          if (aluno.configuracao_id !== this.user.configuracao_id) {
            this.$modals.warn({
              title: "Você gostaria de transferir esse(a) aluno(a)?",
              message: `Encontramos o(a) aluno(a) <strong>${aluno.nomecompleto}</strong> com INEP <strong>${aluno.codigo_inep}</strong> registrado em outra escola, você gostaria de transferí-lo para sua escola?`,
              buttons: [
                {
                  text: "Cancelar",
                  callback: () => {
                    this.$modals.close();
                  },
                  props: {
                    color: "warning",
                    small: true,
                  },
                },
                {
                  text: "Confirmar",
                  callback: async () => {
                    this.$modals.setOptions({ loading: true });
                    await this.$services.alunosService.atualizarAluno({
                      ...aluno,
                      configuracao_id: this.user.configuracao_id,
                    });
                    this.$modals.close();
                    this.$toast.success("Aluno transferido com sucesso!");
                    this.$router.push({ name: "alunos" });
                  },
                  props: {
                    color: "success",
                    // text: true,
                    small: true,
                  },
                },
              ],
            });
          } else {
            this.$modals.info({
              title: "Este(a) aluno(a) já está cadastrado na sua escola!",
              message: "Verificamos que este(a) aluno(a) já está cadastrado na sua escola, ",
              buttons: [
                {
                  text: "Confirmar",
                  callback: () => {
                    this.$modals.close();
                    this.$toast.info("Este(a) aluno(a) já está cadastrado na sua escola");
                    this.$router.push({ name: "alunos" });
                  },
                  props: {
                    color: "success",
                    small: true,
                  },
                },
              ],
            });
          }
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.pesquisandoINEP = false;
    },
    atualizarImagemAluno(event) {
      this.imgAlunoUrl = event.url;
      this.imgAlunoName = event.name;
    },

    atualizarImagemCarteira(event) {
      this.imgCarteiraUrl = event.url;
      this.imgCarteiraName = event.name;
    },
    openTextFieldSaude() {
      this.textFieldOpen =
        this.selectedItemSaude === "Sim" ||
        this.selectedItemAcompanhamento === "Sim" ||
        this.selectedItemRestricao === "Sim" ||
        this.selectedItemDisturbio === "Sim" ||
        this.selectedItemVacinas === "Sim" ||
        this.selectedItemRestricaoAlimentar === "Sim" ||
        this.selectedItemMedicacao === "Sim" ||
        this.selectedItemGravidezAdolescencia === "Sim";

      this.textFieldValueDetalhe = this.selectedItemSaude ? this.textFieldValueDetalhe : "";
      this.textFieldValueAcompanhamento = this.selectedItemAcompanhamento
        ? this.textFieldValueAcompanhamento
        : "";
      this.textFieldValueRestricao = this.selectedItemRestricao ? this.textFieldValueRestricao : "";
      this.textFieldValueDisturbio = this.selectedItemDisturbio ? this.textFieldValueDisturbio : "";
      this.textFieldValueDisturbioProcedimento = this.selectedItemDisturbio
        ? this.textFieldValueDisturbioProcedimento
        : "";
      this.textFieldValueVacinas = this.selectedItemVacinas ? this.textFieldValueVacinas : "";
      this.textFieldValueGravidezAdolescencia = this.selectedItemGravidezAdolescencia
        ? this.textFieldValueGravidezAdolescencia
        : "";
      this.textFieldValueRestricaoAlimentar = this.selectedItemRestricaoAlimentar
        ? this.textFieldValueRestricaoAlimentar
        : "";
      this.textFieldValueMedicacao = this.selectedItemMedicacao ? this.textFieldValueMedicacao : "";
    },
    preencherCamposCertidao: _.debounce(function (event) {
      const num_certidao = event.target.value;

      this.$set(this.form, "livro", num_certidao.slice(15, 20));
      this.$set(this.form, "folha", num_certidao.slice(20, 23));
      this.$set(this.form, "termo", num_certidao.slice(24, 30));
    }, 1000),
  },
};
</script>

<!-- SASS styling -->
<style lang="scss">
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

.bottomButtons {
  overflow: auto;
}

.btn {
  float: right;
}

.options {
  margin-top: 20px;
  margin-left: 15px;
  font-size: large;
}

.texto {
  margin-left: 8px;
  margin-right: 10px;
  font-size: large;
  padding-bottom: 10px;
}

.step {
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbbbbb;
  border: none;
  border-radius: 50%;
  display: flex;
  opacity: 0.5;
}

.step.active {
  opacity: 1;
}

.step.finish {
  background-color: #04aa6d;
}

.invalid {
  background-color: #ffdddd;
}

.tab {
  display: none;
}

.block {
  display: block;
}

.none {
  visibility: hidden;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.custom-padding {
  padding-top: 35px;
}
</style>
